import React from 'react';

import { SCCustomerDetails } from './css';
import { RenderInput } from '../Common/FormFields';
import { Field } from 'redux-form';

const ChangePassword = () => {
		return(
			<SCCustomerDetails>
				<div className="title-firstname-wrapper">
					<Field
	            		placeholder='Password'
	            		name='password' 
		            	label='Password' 
		            	type='password'
		            	className='email'
		            	component={RenderInput} />

		            <Field
	            		placeholder='Confirm Password'
	            		name='confirmPassword'
		            	label='Confirm Password'
		            	type='password'
		            	className='confirmEmail'
		            	component={RenderInput} />
				</div>
			</SCCustomerDetails>
		);
}
export default ChangePassword;